// extracted by mini-css-extract-plugin
module.exports = {"notFound":"NotFound_notFound__cFHM7"};